export default {
    // 사용자 accessToken
    ACCESS_TOKEN: 'accessToken',
    // HubSelector에서 사용자가 선택한 허브의 정보
    SELECTED_HUB_INFO: 'selectedHubInfo',
    // 허브 정산 테스트 모드 여부
    IS_HUB_ADJUSTMENT_TEST_MODE: 'isHubAdjustmentTestMode',
};
